// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"672":"component---src-pages-test-js","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"672":"96a1eb48f75c854e6e01","678":"a3e199dcd637358e3d3f","883":"c837e142412ae70f14b0"}[chunkId] + ".js";
};